import { render } from "./AccountSpaBooking.vue?vue&type=template&id=12b3400c&scoped=true"
import script from "./AccountSpaBooking.vue?vue&type=script&lang=js"
export * from "./AccountSpaBooking.vue?vue&type=script&lang=js"

import "./AccountSpaBooking.vue?vue&type=style&index=0&id=12b3400c&lang=css"
import "./AccountSpaBooking.vue?vue&type=style&index=1&id=12b3400c&scoped=true&lang=css"
import "./AccountSpaBooking.vue?vue&type=style&index=2&id=12b3400c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b3400c"]])

export default __exports__